export const slice = <T>(files: Array<T>, maxFiles: number | null, sliceFromEnd?: boolean): Array<T> => {
  if (maxFiles === null) {
    return files
  }

  if (sliceFromEnd) {
    return files.slice(-maxFiles)
  }

  return files.slice(0, maxFiles)
}
